import { combineReducers } from 'redux'

import auth from './auth/authReducer'
import common from './common/commonReducer'
import onboarding from './onboarding/onboardingReducer'
import dashboard from './dashboard/reducer'
import assets from './assets/commonReducer'
import conversations from './conversations/reducers'
import activeTrips from './active-trip/reducers'
import attendees from './attendees/reducers'
import cryptoWallet from './crypto-wallet/cryptoWalletReducers';

export default combineReducers({
  auth,
  common,
  onboarding,
  dashboard,
  assets,
  conversations,
  activeTrips,
  attendees,
  cryptoWallet
})
